import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 620,
      "name": "sk.svg",
      "url": "https://apieshop.smako.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 2,
    "name": "Český jazyk",
    "locale": "cs",
    "image": {
      "id": 621,
      "name": "cz.svg",
      "url": "https://apieshop.smako.sk/files/cz.svg?ai=0",
      "custom_title": "cz",
      "is_ai_generated": false
    },
    "is_default": false
  },
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 622,
      "name": "gb.svg",
      "url": "https://apieshop.smako.sk/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
